export const ELLIPSIS = '\u2026';

/**
 * Cuts off a string and adds an ellipsis if it exceeds the max length
 * @param s string
 * @param max (even or add number)
 */
export function doEllipsisCutoff(s: string, max?: number | null): [string, boolean] {
    if (max === undefined || max === null) return [s, false];
    if (max === 0) return ['', s !== ''];
    if (max === 1) {
        if (s.length === 1) return [s, false];
        return [ELLIPSIS, true];
    }
    if (s.length > max) {
        const ellipsisLength = 1;
        const max1 = Math.floor((max - ellipsisLength) / 2);
        const max2 = Math.ceil((max - ellipsisLength) / 2);
        let start = s.substring(0, max2);
        let end = s.substring(s.length - max1);
        return [`${start}${ELLIPSIS}${end}`, true];
    } else {
        return [s, false];
    }
}

